import apiUrl from '../../../../constants'
import axios from 'axios'
import {
	Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'

export default {
	name: 'falcon-client-details',
	components: {
		VueElementLoading,
		BasicSelect
	},
	data: function() {
		return {
			showTable: false,
			isLoadingSearch: false,
			clientDetails:[],
			clientObjData: {
				id: "",
				text: ""
			},
			Client:"",
			ClientResult:[],
			clientLoading:''
		}
	},
	created: function() {},
	computed: {},
	// filters: {
  //   isActive: function(isactive) {
	// 		if (isactive == 1) {
	// 			return true;
	// 		} else {
	// 			return false;
	// 		}
  //   }
	// },
	mounted() {
		this.loadClientDetails();
	},
	methods: {
		onSubmit: function() {
			this.$validator.validateAll()
				.then((result) => {
					if (!result) {
						return false;
					}
					this.getClientList();
				}).catch(() => {
					console.log('errors exist', this.errors);
				});
		},
		loadClientDetails() {
			this.clientDetails = []
			this.input = ({
				BusinessFlow: "Forward",
				BusinessService: "Delivery"
			})
			this.clientLoading = 'Loading Client...'
			axios({
				method: "POST",
				'url': apiUrl.api_url_hubops + 'clientbusiness/account/names/flowservice',
				'data': this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
					var response = result.data
					if (response.ResultCode == 100 && response.ResponseData.length > 0) {
						for (var i = 0; i < response.ResponseData.length; i++) {
							this.clientDetails.push({
								id: response.ResponseData[i].ClientMasterID,
								text: response.ResponseData[i].clientaccountnamealise + '(' + response.ResponseData[i].ClientMasterID + ')',
							})
						}
					}
					this.clientLoading = '';
				}, error => {
					this.clientLoading = ''; console.log(error)
				})
		},
		selectedClient(clientObjData) {
			this.clientObjData = clientObjData
			this.Client = this.clientObjData.text
		},
		getClientList() {
			this.showTable = false;
			if (this.clientObjData.id== undefined) {
				return false;
			} else {
				this.isLoadingSearch = true
				this.ClientResult = [];
				var tempMemberarray = [];
				var tempfinalArray = [];
				this.listEventDetails = [];
				this.input = ({})
				axios({
						method: 'GET',
						'url': apiUrl.api_url_hubops + 'fetchClientShipmentRuleByClientId?clientBusinessAccountId=' + this.clientObjData.id,
						'data': this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25'
						}
					})
					.then(result => {
						if (result.data.ResultCode == 100) {
							this.ClientResult = result.data.ResponseData
							this.showTable = true;
						}else{
							this.$alert(result.data.ReturnMessage);
						}
						this.isLoadingSearch = false
					}, error => {
						this.isLoadingSearch = false
						console.error(error)
					})
			}
		},
		resetForm() {
			this.clientObjData = {
				id: '',
				text: ''
			}
			this.Client = ''
			this.clientLoading = ''
			this.isLoadingSearch = false;
			this.showTable = false;
			this.$validator.reset();
			this.errors.clear();
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/ChennaiSorter/FalconClientDetails/FalconClientDetails.js